import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  KioskCard,
  KioskInfo,
  KioskId,
  KioskStatus,
  KiosksBarWrapper,
  KiosksLabel,
  KiosksRow,
  ActionButton,
  StatusDot
} from './KiosksBar.styles'

const KIOSK_STATUSES = ['active', 'idle', 'help', 'age-check', 'active', 'idle']

const KiosksBar = () => {
  const { t } = useTranslation()
  const initialStatuses = useMemo(() => KIOSK_STATUSES.map(s => s), [])
  const [kiosks, setKiosks] = useState(initialStatuses)

  useEffect(() => {
    // Randomly change a kiosk status every 8-15 seconds for demo
    const interval = setInterval(() => {
      setKiosks(prev => {
        const copy = [...prev]
        const idx = Math.floor(Math.random() * 6)
        const statuses = ['active', 'idle', 'help', 'age-check']
        copy[idx] = statuses[Math.floor(Math.random() * statuses.length)]
        return copy
      })
    }, 30000)
    return () => clearInterval(interval)
  }, [])

  const handleValidateAge = (idx) => {
    setKiosks(prev => {
      const copy = [...prev]
      copy[idx] = 'active'
      return copy
    })
  }

  const handleAcknowledgeHelp = (idx) => {
    setKiosks(prev => {
      const copy = [...prev]
      copy[idx] = 'active'
      return copy
    })
  }

  const statusLabel = (status) => t(`kiosks.status.${status}`, { defaultValue: status })

  return (
    <KiosksBarWrapper>
      <KiosksLabel>{t('kiosks.title')}</KiosksLabel>
      <KiosksRow>
        {kiosks.map((status, idx) => {
          const needsAction = status === 'help' || status === 'age-check'
          return (
            <KioskCard key={idx} $status={status} $wide={needsAction}>
              <KioskInfo>
                <KioskId>
                  <StatusDot $status={status} $pulse={needsAction} />
                  {t('kiosks.id', { number: idx + 1 })}
                </KioskId>
                <KioskStatus $status={status} title={statusLabel(status)}>{statusLabel(status)}</KioskStatus>
              </KioskInfo>
              {status === 'age-check' && (
                <ActionButton type="button" $variant="age" onClick={() => handleValidateAge(idx)}>
                  {t('kiosks.validateAge')}
                </ActionButton>
              )}
              {status === 'help' && (
                <ActionButton type="button" $variant="help" onClick={() => handleAcknowledgeHelp(idx)}>
                  {t('kiosks.assist')}
                </ActionButton>
              )}
            </KioskCard>
          )
        })}
      </KiosksRow>
    </KiosksBarWrapper>
  )
}

export default KiosksBar
